// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ClaimsProcessorAttributeResponse } from './claims-processor-attribute-response';

/** See com.rev360.pms.api.controller.admin.practicepreferences.InsuranceClaimProcessorResponse */
/* istanbul ignore next */
@GandalfModel
export class InsuranceClaimProcessorResponse extends GandalfModelBase {

	@GandalfArray(ClaimsProcessorAttributeResponse)
	claimsProcessorAttributes!: ClaimsProcessorAttributeResponse[] | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: String })
	fax!: string | null;

	@GandalfProperty({ designType: String })
	informationUrl!: string | null;

	@GandalfProperty({ designType: String })
	loginUrl!: string | null;

	@GandalfProperty({ designType: String })
	mainPhone!: string | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: Number })
	processorId!: number | null;

	@GandalfProperty({ designType: Number })
	statementProcessorId!: number | null;

	@GandalfProperty({ designType: String })
	tollFreePhone!: string | null;

}
